export default {
    computed: {
        userId() {
            const auth = this.$store.getters.getAuth;
            return auth.userId;
        }
    }
};
